import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const parseDeliveryIdentifier = (
  searchString: string
): string | undefined => {
  const raw = new URLSearchParams(searchString).get('delivery')?.trim();
  return raw ? raw : undefined;
};

export const useDeliveryIdentifier = (): string | undefined => {
  const [searchParams] = useSearchParams();
  return useMemo(
    () => parseDeliveryIdentifier(searchParams.toString()),
    [searchParams]
  );
};
